import { InjectionToken } from '@angular/core';

export const SET_VALUES_CONSTRUCTOR = new InjectionToken<boolean>(
  'Helps the app-table component to define  if it need to set up the variables itself or the child can do it',
  {
    providedIn: 'root',
    factory: () => true,
  }
);
